import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '@vectord/components';

import {
  isBlacklistedMenteeModalOpenSelector,
  setPersonalisedMenteeEmailersFilterModalState,
} from 'features/communicationManagement';
import FilterDrawerContent from '../FilterDrawerContent';
import styles from './FilterDrawer.module.scss';

function FilterDrawer() {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(isBlacklistedMenteeModalOpenSelector);

  const handleModalClose = useCallback(() => {
    dispatch(setPersonalisedMenteeEmailersFilterModalState(false));
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={handleModalClose}
      position="right"
      unMountOnClose
      withoutHeader
      className={styles.root}
      containerClassName={styles.containerClassName}
      hasCloseButton={false}
      size="large"
    >
      <FilterDrawerContent />
    </Modal>
  );
}

export default FilterDrawer;
